import { mergeMap, catchError, map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import LoginService from '../../authentication/login/login-service';
import { EMPTY, of } from 'rxjs';
import * as UserApi from './user.api';
import * as Actions from './user.actions';

const userSettingPrefix = 'v3.';

export const hydrateCurrentUser = (action$) => {
  return action$.pipe(
    ofType(Actions.CURRENT_USER_HYDRATE),
    mergeMap(() => {
      const cachedCurrentUserInfo = LoginService.getCurrentUserInfo();
      if (cachedCurrentUserInfo) {
        return of(Actions.getCurrentUserSuccess(cachedCurrentUserInfo), Actions.getCurrentUser());
      }

      return of(Actions.getCurrentUser());
    }),
  );
};

export const getCurrentUser = (action$) => {
  return action$.pipe(
    ofType(Actions.CURRENT_USER_GET_REQUEST),
    mergeMap(() => {
      return UserApi.getCurrentUser().pipe(
        map((resp) => {
          const currentUserInfo = resp.data;
          if (currentUserInfo) {
            LoginService.setCurrentUserInfo(currentUserInfo);
          }
          return Actions.getCurrentUserSuccess(currentUserInfo);
        }),
        catchError(() => EMPTY),
      );
    }),
  );
};

export const saveUserSetting = (action$) => {
  return action$.pipe(
    ofType(Actions.USER_SETTING_SAVE_REQUEST),
    mergeMap((action) => {
      const { setting } = action;
      const { settingName, excludeV3prefix } = setting;
      setting.settingName = excludeV3prefix ? settingName : `${userSettingPrefix}${setting.settingName}`;
      if (typeof setting.settingValue === 'object') {
        setting.settingValue = JSON.stringify(setting.settingValue);
      }
      return UserApi.saveUserSetting(setting).pipe(
        map(() => Actions.saveUserSettingSuccess(setting)),
        catchError(() => EMPTY),
      );
    }),
  );
};

const gridTypeToBaseSettingNameMap = {
  shipments: 'shipments.gridConfig',
  orders: 'orders.gridConfig',
  customers: 'customers.gridConfig',
  products: 'products.gridConfig',
  inventory: 'inventory.gridConfig',
  externalInventory: 'externalInventory.gridConfig',
  fulfillments: 'fulfillments.gridConfig',
};

// TODO: dispatch saveUserSetting from column change epics instead of separate dispatches littered everywhere, like returns
export const saveUserGridConfig = (action$) => {
  return action$.pipe(
    ofType(Actions.USER_SETTING_SAVE_GRID_CONFIG),
    mergeMap((action) => {
      const { gridType, statusViewId, filterViewId, gridConfig } = action;
      if (filterViewId === 'custom') {
        return EMPTY;
      }
      const baseSettingName = gridTypeToBaseSettingNameMap[gridType];

      if (!baseSettingName) {
        return EMPTY;
      }

      const settingName = `${baseSettingName}.${statusViewId}.${filterViewId}`;
      const setting = {
        settingName: `${userSettingPrefix}${settingName}`,
        settingValue: JSON.stringify(gridConfig),
      };
      return UserApi.saveUserSetting(setting).pipe(
        map(() => Actions.saveUserSettingSuccess(setting)),
        catchError(() => EMPTY),
      );
    }),
  );
};
